import { Link } from 'react-router-dom';
import { Gauge } from 'lucide-react';
import { useMe } from '@/lib/api';
import { formatInt } from '@/lib/utils';
import './billing.css';

/**
 * O restante do mês do plano gratuito, numa linha discreta no rodapé da barra
 * lateral, acima do chip da conta (só com a barra expandida). Só existe para quem
 * é `free` — um assinante não tem teto para contar — e o clique leva a /planos, a
 * única ação que o número pede. A contagem inteira mora na Visão geral (o
 * indicador "Plano"); aqui é o lembrete ambulante, invalidado a cada resposta do
 * chat junto com o /me.
 */
export function PlanQuotaBadge(): JSX.Element | null {
  const me = useMe();
  const plan = me.data?.plan;
  const usage = me.data?.tokenUsage;
  if (!plan || plan.status !== 'free' || !usage) return null;

  const label = `Restam ${formatInt(usage.tokensRemaining)} tokens`;
  return (
    <Link
      to="/planos"
      className="plan-quota"
      aria-label={`Plano gratuito: ${label.toLowerCase()} este mês. Conhecer o Pro.`}
      title="Plano gratuito — conhecer o Pro"
    >
      <Gauge size={16} aria-hidden="true" />
      <span className="plan-quota__label">{label}</span>
    </Link>
  );
}
